var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":"处方审核系统","fixed":"","placeholder":""},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('van-icon',{attrs:{"name":"chat-o","badge":_vm.messageList},on:{"click":_vm.handleMessage}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }